// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientTCEntLib2SecuritySecureModelsSecureInt64Response {
    'success': boolean;
    'messages': Array<string>;
    'data': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientTCEntLib2SecuritySecureModelsSecureInt64Response>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PatientTCEntLib2SecuritySecureModelsSecureInt64Response.attributeTypeMap;
    }
}
